import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { Router } from "@angular/router";
import { NavController } from "@ionic/angular";
import { BobToastService } from "src/app/shared/toast";
import { TranslateService } from "@ngx-translate/core";
import { AppService } from "src/app/_services/app.service";
import { StripeService } from "src/app/_services/stripe.service";

@Component({
  selector: "app-select-payment-modal",
  templateUrl: "./select-payment-modal.component.html",
  styleUrls: ["./select-payment-modal.component.scss"],
  standalone: false,
})
export class SelectPaymentModalComponent implements OnInit {
  data: any = null;
  userCards: any = null;
  defaultCard: any = null;
  soldError: boolean = false;
  @Input() loading: boolean = false;
  @Input() modalType: string = "PAYMENT";
  @Output() cancle: EventEmitter<any> = new EventEmitter<any>();
  @Output() confirm: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private appService: AppService,
    private router: Router,
    private navController: NavController,
    private stripeService: StripeService,
    private translate: TranslateService,
    private bobToast: BobToastService
  ) {}
  ngOnInit(): void {
    this.getCards();
    this.subscribeCreateDemandeData();
  }
  getCards() {
    this.loading = true;
    this.stripeService.getCard().subscribe((cards: any) => {
      this.loading = false;
      this.userCards = cards;
      let defaultCard = cards.filter((card: any) => {
        return card.default === 1;
      });
      this.defaultCard = defaultCard[0];
    });
  }
  subscribeCreateDemandeData() {
    this.appService.createDemandeDataObservable().subscribe((data: any) => {
      if (data != null && data != undefined) {
        this.data = data;
      }
    });
  }
  closeModal() {
    this.appService.dispatchModal("CHECK_PAYMENT_MODAL", false);
    this.cancle.emit();
  }
  navigateToPaymentMethods() {
    this.closeModal();
    setTimeout(() => {
      this.router.navigate(["/particulier/configurations/payment-methods"]);
    }, 100);
  }

  submit() {
    if(this.defaultCard) {
      if (this.confirm) {
        this.confirm.emit();
      } else {
        this.submitDemand();
      }
    } else {
      this.navigateToPaymentMethods();
    }
  }
  submitDemand() {
    if (this.userCards.length && this.defaultCard != null) {
      this.loading = true;
      const formData = new FormData();
      formData.append("statut", "PENDING");
      formData.append("description", this.data.description);
      if (this.data.image_urls && this.data.image_urls.length) {
        for (let i = 0; i < this.data.image_urls.length; i++) {
          formData.append(`image_urls[]`, this.data.image_urls[i]);
        }
      }
      formData.append("user_id", this.data.user_id);
      formData.append("domaine", this.data.domaine);
      this.data.selectedExperience &&
        formData.append("specialitie", this.data.id);
      this.data.recordedAudioFilePath &&
        formData.append("audio", this.data.recordedAudioFilePath);
      this.data.recordedAudioFileDuration > 0 &&
        formData.append("duration", this.data.recordedAudioFileDuration);
      formData.append("lat", this.data.lat);
      formData.append("lng", this.data.lng);
      formData.append("position", this.data.position);
      try {
        this.appService.createDemand(formData).subscribe({
          next: (res: any) => {
            this.loading = false;
            const id = res.body.id;
            this.closeModal();
            this.appService.dispatchdata("DEMANDE_TO_CREATE", null);
            this.appService.dispatchModal("FREE_DEMAND_CLIENT_MODAL", true);

            setTimeout(() => {
              this.navController.navigateForward([
                "/particulier/services-around/" + id,
              ]);
            }, 50);
          },
          error: (err: any) => {
            this.closeModal();
            this.soldError = true;
            this.loading = false;
            for (let i = 0; i < this.data.image_urls.length; i++) {
              if (err.error.errors["image_urls." + i]) {
                void this.bobToast.errorBottom(
                  this.translate.instant("DEMANDE_SERVICES.IMAGES.ERROR_" + i),
                  { duration: 3000 }
                );
              }
            }
          },
        });
      } catch (error) {
        this.loading = false;
      }
    }
  }
}
